// debugLogger.js
export const debug = {
  log: (module, ...args) => {
    console.log(`DEBUG_FILTER: [${module}]`, ...args);
  },
  error: (module, ...args) => {
    console.error(`[${module}]`, ...args);
  }
};